<div class="container">	
	<!-- <div class="padded-div">
		<mat-icon>wrong_location</mat-icon>
	</div> -->
	<div class="padded-div">
		<p><b>No results found</b></p>
	</div>

</div>